import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Pagination } from 'src/app/domain/views/pagination.view';
import { InvoiceFullDetails } from 'src/app/business/models/billing/invoice-full-details.model';
import { InvoiceDetails } from 'src/app/business/models/billing/invoice-details.model';

@Component({
  selector: 'app-invoices-admin-cards',
  templateUrl: './cards.component.html'
})
export class AdminInvoicesCardsComponent implements OnInit {

  @Input() invoices: Array<InvoiceFullDetails>;

  @Input() pagination: Pagination;

  @Input() noResults: boolean;

  @Output() invoiceDownload = new EventEmitter<InvoiceDetails>();

  @Output() invoiceDetails = new EventEmitter<number>();

  @Output() resendPaymentRequest = new EventEmitter<number>();

  @Output() paymentToProvider = new EventEmitter<number>();

  @Output() manualSettleUp = new EventEmitter<number>();


  constructor() { }

  ngOnInit() { }


  onInvoiceDownload(invoiceDetails: InvoiceDetails) {
    this.invoiceDownload.emit(invoiceDetails);
  }

  onResendPaymentRequest(invoiceId: number) {
    this.resendPaymentRequest.emit(invoiceId);
  }

  onInvoiceDetails(invoiceId: number) {
    this.invoiceDetails.emit(invoiceId);
  }

  onPaymentToProvider(invoiceId: number) {
    this.paymentToProvider.emit(invoiceId);
  }

  onManualSettleUp(invoiceId: number) {
    this.manualSettleUp.emit(invoiceId);
  }

}
